export const getEnvVariable = (key: string): string | undefined => {
  const envKey = `VITE_${key}`
  return import.meta.env[envKey]
}

// Feature flags
export const ENABLE_SPACE_COUNT_PRECALCULATION = true // Set to false to disable space count precalculation

// Gates agreement-consent capture (onboarding checkbox + login-gate modal).
// Off unless VITE_AGREEMENT_CONSENT_ENABLED is explicitly 'true' for the environment.
// Global build-time flag (NOT the entity `FeatureFlag` system): the gate must also run at
// onboarding, where the new invitee has no active_entity yet, and consent is a global legal
// requirement rather than a per-entity capability.
export const AGREEMENT_CONSENT_ENABLED = import.meta.env.VITE_AGREEMENT_CONSENT_ENABLED === 'true'

export const getInboundEmailHost = () => {
  // `window` is undeclared in Cloudflare Workers — referencing it throws
  // ReferenceError before optional chaining can evaluate. Guard with `typeof`.
  if (typeof window !== 'undefined' && window.location?.hostname === 'app.revelstreet.co') {
    return 'inbox.revelstreet.co'
  }
  if (import.meta.env.VITE_ENV_ROLE === 'production') {
    return 'inbox.revelstreet.co'
  }
  return 'resend-preview.revelstreet.co'
}
